// import { commonProps } from "../CommonFunctions/commonTypes";
import { commonProps } from "../../../Features/commonTypes";
export const check = (attachmentMandatoryOptArr: Array<string>) => {
  if (!attachmentMandatoryOptArr.length) return { visible: false, value: 0 };
  else return { visible: true, value: 4 }; // Ensure to return false if no conditions match
};

const messageGenerator = (
  encodedState: number,
  attachmentOptionNameArr: Array<string>,
  noteOptionNameArr: Array<string>,
  attachmentRequired: boolean,
  noteRequired: boolean
) => {
  switch (encodedState) {
    case 0:
    case 1:
      return "";

    case 2:
      return (
        <div className="mandatory">
          {attachmentOptionNameArr.length > 0 ? (
            <span className="mandatory-child">
              {`Attachment is mandatory for ${attachmentOptionNameArr.join(
                "/"
              )}.`}
              .
            </span>
          ) : (
            <span className="mandatory-child">Attachment is mandatory.</span>
          )}
        </div>
      );
    case 3:
      return (
        <div className="mandatory">
          <span className="mandatory-child">
            {" "}
            {attachmentOptionNameArr.length > 0 ? (
              <span className="mandatory-child">
                {`Attachment is mandatory for ${attachmentOptionNameArr.join(
                  "/"
                )}.`}
              </span>
            ) : (
              <span className="mandatory-child">Attachment is mandatory.</span>
            )}
          </span>
        </div>
      );
    case 4:
      return (
        <div className="mandatory">
          <span className="mandatory-child">
            {`Attachment is mandatory for ${attachmentOptionNameArr.join(
              "/"
            )}.`}
          </span>
        </div>
      );
    case 5:
      return (
        <div className="mandatory">
          <span className="mandatory-child">
            {" "}
            {attachmentOptionNameArr.length > 0 ? (
              <span className="mandatory-child">
                {`Attachment is mandatory for ${attachmentOptionNameArr.join(
                  "/"
                )}`}
                .
              </span>
            ) : (
              <span className="mandatory-child">Attachment is mandatory.</span>
            )}
          </span>
        </div>
      );
    case 6:
    case 7:
    case 8:
    case 9:
      return "";

    case 10:
      return (
        <div className="mandatory">
          {attachmentRequired && (
            <span className="mandatory-child">
              {noteRequired && "1. "}
              {attachmentOptionNameArr.length > 0 ? (
                <span className="mandatory-child">
                  {`Attachment is mandatory for ${attachmentOptionNameArr.join(
                    "/"
                  )}.`}
                </span>
              ) : (
                <span className="mandatory-child">
                  Attachment is mandatory.
                </span>
              )}
            </span>
          )}
          {noteRequired && (
            <span className="mandatory-child">
              {attachmentRequired && "2. "} Note is Mandatory.
            </span>
          )}
        </div>
      );
    case 11:
    case 12:
    case 13:
    case 14:
    case 15:
    case 16:
    case 17:
      return (
        <div className="mandatory">
          {attachmentRequired && (
            <span className="mandatory-child">
              {noteRequired && "1. "}
              {attachmentOptionNameArr.length > 0 ? (
                <span className="mandatory-child">
                  {`Attachment is mandatory for ${attachmentOptionNameArr.join(
                    "/"
                  )}.`}
                </span>
              ) : (
                <span className="mandatory-child">
                  Attachment is mandatory.
                </span>
              )}
            </span>
          )}

          {noteRequired && (
            <span className="mandatory-child">
              {attachmentRequired && "2. "}
              {noteOptionNameArr.length > 0 ? (
                <span className="mandatory-child">
                  {`Note is mandatory for ${noteOptionNameArr.join("/")}.`}
                </span>
              ) : (
                <span className="mandatory-child">Note is mandatory.</span>
              )}
            </span>
          )}
        </div>
      );

    default:
      break;
  }
};
function encodeStates(
  isQuestionMandatory: boolean,
  isAttachmentMandatoryForQuestion: boolean,
  isAttachmentMandatoryForOptions: boolean,
  isNoteMandatory: boolean,
  attachmentOptions: Array<string>,
  noteOptions: Array<string>,
  isNoteMandatoryForQuestion: boolean,
  isNoteMandatoryForOptions: boolean
) {
  return (
    (isQuestionMandatory ? 1 : 0) +
    (isAttachmentMandatoryForQuestion ? 2 : 0) +
    (isAttachmentMandatoryForOptions ? check(attachmentOptions).value : 0) +
    (isNoteMandatory ? 8 : 0) +
    (isNoteMandatoryForQuestion ? 2 : 0) +
    (isNoteMandatoryForOptions ? check(noteOptions).value : 0)
  );
}
export function generateMessage(
  isQuestionMandatory: boolean,
  isAttachmentMandatoryForQuestion: boolean,
  isAttachmentMandatoryForOptions: boolean,
  attachmentMandatoryOptArr: Array<string>,
  noteMandatoryOptArr: Array<string>,
  isNoteMandatory: boolean,
  optionInfo: any,
  isNoteMandatoryForQuestion: boolean,
  isNoteMandatoryForOptions: boolean
) {
  const encodedState: number = encodeStates(
    isQuestionMandatory,
    isAttachmentMandatoryForQuestion,
    isAttachmentMandatoryForOptions,
    isNoteMandatory,
    attachmentMandatoryOptArr,
    noteMandatoryOptArr,
    isNoteMandatoryForQuestion,
    isNoteMandatoryForOptions
  );

  const message = messageGenerator(
    encodedState,
    attachmentMandatoryOptArr.map(
      (ele) => optionInfo?.optionObj[ele]?.optionName
    ),
    noteMandatoryOptArr.map((ele) => optionInfo?.optionObj[ele]?.optionName),
    isAttachmentMandatoryForQuestion || isAttachmentMandatoryForOptions
      ? true
      : false,
    isNoteMandatoryForQuestion || isNoteMandatoryForOptions ? true : false
  );

  return message;
}
